<template>
    <div class="w-100 d-flex flex-column align-start">
        <div class="toggle">
            <div class="toggle__button-container">
                <button class="rounded-pill text-transform-none h-100 toggle__button"
                    :class="activeStatus === OfferStatus.Started ? 'toggle__button--selected' : 'toggle__button--unselected'"
                    @click="changeStatus(OfferStatus.Started)">
                    In Progress
                </button>

                <button class="rounded-pill text-transform-none h-100 toggle__button"
                    :class="activeStatus === OfferStatus.Completed ? 'toggle__button--selected' : 'toggle__button--unselected'"
                    @click="changeStatus(OfferStatus.Completed)">
                    Completed
                </button>

                <button class="rounded-pill text-transform-none h-100 toggle__button"
                    :class="activeStatus === OfferStatus.Expired ? 'toggle__button--selected' : 'toggle__button--unselected'"
                    @click="changeStatus(OfferStatus.Expired)">
                    Expired
                </button>
            </div>
        </div>

        <div class="w-100 mt-10">
            <slot :name="activeStatus"></slot>
        </div>
    </div>
</template>



<script setup>
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from 'vue-router';
import { OfferStatus } from "@/interfaces/Offers/OfferStatus";

// Router setup
const route = useRoute();
const router = useRouter();

// Status mapping for URL parameters
const statusMap = {
  'in-progress': OfferStatus.Started,
  'completed': OfferStatus.Completed,
  'expired': OfferStatus.Expired
};

// Initialize active status from route if available
const initialStatus = statusMap[route.params.status] || OfferStatus.Started;
const activeStatus = ref(initialStatus);

// Helper function to get key by value for statusMap
function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

const changeStatus = (status) => {
  activeStatus.value = status;
  
  // Change the URL without navigating to re-use the same component
  router.replace({ name: 'Offer Status', params: { status: getKeyByValue(statusMap, status) } });
};

// Initialize with route params if available
onMounted(() => {
  if (route.params.status) {
    const routeStatus = statusMap[route.params.status];
    if (routeStatus) {
      activeStatus.value = routeStatus;
    }
  }
});
</script>

<style scoped>
.toggle {
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.toggle__button-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  width: 100%;
  max-width: 420px;
  height: 48px;
  gap: 4px;
}

.toggle__button {
  font-size: 14px;
  padding: 0 8px;
  white-space: nowrap;
}

/* Mobile responsiveness */
@media (max-width: 480px) {
  .toggle__button {
    font-size: 12px;
    padding: 0 4px;
  }
}
</style>